import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15
  },
  noFocusOutline: {
    borderColor: `${theme.palette.grey[600]} !important` // Removes red focus border
  },
  greyTextFieldLabel: {
    color: `${theme.palette.grey[900]} !important`, // Set TextField label color to grey
    '&.Mui-focused': {
      color: `${theme.palette.grey[900]} !important` // Ensure it stays grey even when focused
    }
  },
  label: {
    paddingLeft: 12,
    fontSize: 14,
    color: `${theme.palette.grey[900]} !important`
  }
}))

export default useStyles
